exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:480px){.src-components-order-styles-___line-item__lineItemName___24zyj{margin-bottom:15px}}.src-components-order-styles-___line-item__lineItemNameDetailContainer___mCYMP{display:flex;flex-direction:row}@media (max-width:480px){.src-components-order-styles-___line-item__lineItemNameDetailContainer___mCYMP{flex-direction:column}}.src-components-order-styles-___line-item__lineItemPhones___32oIZ{text-align:center;width:100%}@media (max-width:480px){.src-components-order-styles-___line-item__lineItemPhones___32oIZ{text-align:left}}", ""]);

// exports
exports.locals = {
	"lineItemName": "src-components-order-styles-___line-item__lineItemName___24zyj",
	"lineItemNameDetailContainer": "src-components-order-styles-___line-item__lineItemNameDetailContainer___mCYMP",
	"lineItemPhones": "src-components-order-styles-___line-item__lineItemPhones___32oIZ"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/order/styles/line-item.scss
 ** module id = 891
 ** module chunks = 0
 **/